import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { token, role } = user;

    if (token && role) {
      switch (role) {
        case 'USER_KYC':
          this.router.navigate(['/UserKycDashboard']);
          break;
        case 'REP_KYC':
          this.router.navigate(['homepage/repkycdashboard']);
          break;
        case 'REP_POB':
          this.router.navigate(['/homepage/hcpselection']);
          break;
        case 'REP_ALL':
          this.router.navigate(['/homepage']);
          break;
        default:
          this.router.navigate(['/not-found']);
      }
      return false; // Prevent login page access
    }
    return true; // Allow login page access if no token
  }
}
